module.exports = __webpack_public_path__ + "img/Moana.65050bca.jpeg";